import React, { useState, useEffect } from "react";

import { Dropdown } from 'primereact/dropdown';
import { Message } from 'primereact/message';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';

import servicioHttp from '../../../servicio/ServicioHttp';
import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR } from '../../../servicio/ServicioConstantes';
import servicioObjetos from "../../../servicio/ServicioObjetos";
import servicioFormatos from "../../../servicio/ServicioFormatos";


export const FormularioBusqueda = (props) => {

    const [registrosPatronales, setRegistrosPatronales] = useState([]);
    const [frmConsulta, setFrmConsulta] = useState({});
    const [errores, setErrores] = useState({});
    const {onFormularioOk} =props;

    useEffect(() => {
        obtenerRegistrosPatronales();
    }, []);

    const obtenerRegistrosPatronales = () => {
        servicioHttp.consumirPostHttp('empresa/obtener_registro_patronal.json').then(response => {
            const TODOS = { label: "Todos", value: 0 };
            let registrosPatronales = [TODOS];
            var newArray = registrosPatronales.concat(response.data.lista);
            setRegistrosPatronales(newArray);
        }).catch(error => {

        });
    };

    const handleChange = (e, mayusculas) => {
        const { name, value } = e.target;
        let elValor = value;
        if (mayusculas) {
            if (elValor && typeof elValor !== 'object')
                elValor = elValor.toUpperCase();
        }
        setFrmConsulta((prevMovimiento) => {
            const newMovimiento = { ...prevMovimiento }
            if (name.includes(".")) {
                let elementos = name.split(".");
                var nombreObjeto = elementos[0];
                var laPropiedad = elementos[1];
                newMovimiento[nombreObjeto][laPropiedad] = elValor;
            } else {
                newMovimiento[name] = elValor;
            }
            return newMovimiento;
        });
    };

    const reiniciarFormulario = () => {
        setFrmConsulta({});
        setErrores({});
    }

    const validarFormulario = () => {
        let errores = {};
        if (servicioObjetos.esObjetoVacio(frmConsulta.registroPatronal)) {
            errores.registroPatronal = "Atributo requerido para la consulta";
        }

        if (servicioObjetos.esObjetoVacio(frmConsulta.fechaInicial) && !servicioObjetos.esObjetoVacio(frmConsulta.fechaFinal)) {
            errores.fechaInicial = "La fecha inicial es requerida";
        }

        if (!servicioObjetos.esObjetoVacio(frmConsulta.fechaInicial) && servicioObjetos.esObjetoVacio(frmConsulta.fechaFinal)) {
            errores.fechaFinal = "La fecha final es requerida";
        }
        return errores;
    }

    const buscar = () => {
        let erroresForm = validarFormulario();
        setErrores(erroresForm);
        if (servicioObjetos.esObjetoVacio(erroresForm)) {
            let empresasUsuarioSesion = [];
            if (frmConsulta.registroPatronal === 0) {
                for (let index = 0; index < registrosPatronales.length; index++) {
                    let elemento = registrosPatronales[index];
                    if (elemento.value !== 0) {
                        let valor = elemento.value;
                        empresasUsuarioSesion.push(
                            valor
                        );
                    }
                }
            } else {
                empresasUsuarioSesion.push(frmConsulta.registroPatronal);
            }

            let restricciones=[{
                tipoRestriccion: "in",
                nombrePropiedad: "alias_tcEmpresa.id",
                coleccionIn: empresasUsuarioSesion
            },
            {
                tipoRestriccion:'eq',
                nombrePropiedad:'estado',
                valorPropiedad:2
            },{
                tipoRestriccion:'isNotNull',
                nombrePropiedad:'loteIdImss',
            }];
           
            if (!servicioObjetos.esObjetoVacio(frmConsulta.fechaInicial) && !servicioObjetos.esObjetoVacio(frmConsulta.fechaFinal)) {
                let fechaIncial = servicioFormatos.formatearFechaString(frmConsulta.fechaInicial);
                let fechaFinal = servicioFormatos.formatearFechaString(frmConsulta.fechaFinal).replace('00:00:00', '23:59:59');
                let restriccionFecha = {
                    tipoRestriccion: "between",
                    nombrePropiedad: "fecha",
                    valorPropiedad: null,
                    fechaIncialBetween: fechaIncial,
                    fechaFinalBetween: fechaFinal
                };
                restricciones.push(restriccionFecha);
            }

            const paginacion = {
                registrosPorPagina: 20,
                registrosTotales: 0,
                numeroPagina: 0,
                restriccionesDinamicas: restricciones
            };
            onFormularioOk(paginacion);           
        }
    }

    return (
        <div className="card">
            <h1>Txt Casa Ley</h1>
            <p>En esta sección usted puede descargar los archivos .txt en el formato solicitado</p>

            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-4">
                    <h3>Registro Patronal</h3>
                    <Dropdown filter={true} filterPlaceholder="Filtra por RP o Nombre corto" filterBy="value,label" showClear={true}
                        appendTo={document.body} id="registroPatronal" name="registroPatronal" optionLabel="label" optionValue="value"
                        options={registrosPatronales} value={frmConsulta.registroPatronal}
                        onChange={(e) => handleChange(e, false)}
                        autoWidth={false} style={{ width: "100%" }} className={errores.registroPatronal ? "p-error" : ""} />
                    {errores.registroPatronal ? <div><Message severity="error" text={errores.registroPatronal} /></div> : null}
                </div>
                <div className="p-col-12 p-md-4">
                    <h3>Fecha Inicial cargado en EMICA</h3>
                    <Calendar dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX} id="fechaInicial"
                        name="fechaInicial" value={frmConsulta.fechaInicial} onChange={(e) => handleChange(e, false)}
                        className={errores.fechaInicial ? 'p-error' : ''} />
                    {errores.fechaInicial ? <div><br /> <Message severity="error" text={errores.fechaInicial} /> </div> : null}
                </div>
                <div className="p-col-12 p-md-4">
                    <h3>Fecha Final cargado en EMICA</h3>
                    <Calendar dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX} id="fechaFinal"
                        name="fechaFinal" value={frmConsulta.fechaFinal} onChange={(e) => handleChange(e, false)}
                        className={errores.fechaFinal ? 'p-error' : ''} />
                    {errores.fechaFinal ? <div><br /> <Message severity="error" text={errores.fechaFinal} /> </div> : null}
                </div>

                <div className="p-col-12 p-md-2">
                    <Button label="Limpiar" icon="pi-md-refresh" onClick={reiniciarFormulario} />
                </div>
                <div className="p-col-12 p-md-2">
                    <Button label="Buscar" icon="pi-md-search" onClick={buscar} />
                </div>
            </div>
        </div>
    );
}